<template>
  <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
    <v-card class="elevation-1 mb-6 rounded-lg">
      <v-card-title class="pa-7">
        {{ title }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pa-7">
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="py-0">
                <div class="request-label">Ulice</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.street ? value.street : '-' }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="py-0">
                <div class="request-label">Č.P.</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.houseNumber2 ? value.houseNumber2 : '-' }}
                </div>
              </v-col>
              <v-col cols="auto" class="py-0">
                <div class="request-label">Č.O.</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.houseNumber ? value.houseNumber : '-' }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="py-0">
                <div class="request-label">Město</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.city ? value.city : '-' }}
                </div>
              </v-col>
              <v-col cols="4" class="py-0">
                <div class="request-label">Místní část</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.district ? value.district : '-' }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="auto" class="py-0">
                <div class="request-label">PSČ</div>
                <div class="request-value mt-2 mb-4">
                  {{ value.postalCode ? value.postalCode : '-' }}
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pl-7 pr-7 pb-7">
        <v-spacer></v-spacer>
        <template>
          <v-btn
            type="submit"
            height="40px"
            min-width="130px"
            color="primary"
            depressed
            :to="{
              name: order ? 'orders.address.edit' : 'customers.address.edit',
              params: order ? { id: id, orderId: orderId } : { id: id, customerId: customerId },
            }"
          >
            Editovat
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
export default {
  name: 'AddressDetail',
  props: {
    value: {
      type: Object,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    orderId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    customerId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    order: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Adresa',
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      loading: false,
      saving: false,
    }
  },
}
</script>
